import {Product} from './product';
import {GenderPrice} from './gender-price';
import {Component} from './component';
import {EventComponent} from './event-component';

export class Event {
  agentsHaveAccessExtras: boolean;
  agentsHaveAccessPickups: boolean;
  availabilityType: number;
  bookingQuestion: string;
  bookingQuestionIsActive: boolean;
  bookingQuestionIsMandatory: boolean;
  end: string;
  eventAlotments: any[];
  eventComponents: EventComponent[];
  eventGenderPrices: GenderPrice[];
  eventNotes: any[];
  eventOccupancyList: any[];
  eventResources: any[];
  eventRoutes: any[];
  eventRouteCustomInfo: string;
  hasLotation: boolean;
  id: number;
  isPriceIncludeTaxes: boolean;
  isPrivateEvent: boolean;
  location: string;
  locationId: number;
  locationMain: any;
  manualConfirmation: boolean;
  maximumLotation: number;
  maximumPaxPerBooking:number;
  minimumLotation:number;
  minimumPaxPerBooking:number;
  notes: string;
  passengerSettings: {
    configurations: any[];
    tieredConfigurations: any[];
    format: number;
  };
  genders: any[];
  product: Product;
  productAvailabilityTypeDescription: string;
  quantityAvailable: number;
  quantityBooked: number;
  rejectBookingBasedOnMinMax:boolean;
  salesPermissionsAgents: boolean;
  salesPermissionsTeam: boolean;
  salesPermissionsWebsite: boolean;
  serviceId: number;
  start: string;
  status: number;
  statusMessage: string;
  supplierId: number;
  supplierName: string;
  duration: string;
  resources: any[];
  widgetHaveAccessExtras: boolean;
  widgetHaveAccessPickups: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/api/model/event.ts